import React, {useEffect, useState} from 'react';
import {Dimmer, Loader, Modal, Segment} from "semantic-ui-react";
import DocsTab from "../form_v3/tabs/docsTab";
import {apiGet} from "../../../services/apiClient";

const DocsModal = ({trigger, setOpen, open, className, form}) => {

    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(false);

    const getDocs = () => {
        setLoading(true);
        apiGet(`parcels/documents/${form.id}/list`).then(res => {
            setDocs((res || {}).entries);
            setLoading(false);
        }).catch(e => {
            console.log(e);
            setLoading(false);
        });
    }

    useEffect(() => {
        (open && form.id) && getDocs();
    }, [open, form.id]);

    return (
        <Modal
            className={className}
            closeIcon
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={trigger}
            size="large"
        >
            <Modal.Header>
                Документы
            </Modal.Header>
            <Segment vertical>
                <Dimmer active={loading} inverted>
                    <Loader size='medium'/>
                </Dimmer>
                <DocsTab
                    isModal
                    form={form}
                    documents={docs}
                />
            </Segment>
        </Modal>
    );
};

export default DocsModal;


// WEBPACK FOOTER //
// ./App/pages/parcels/table/docsModal.jsx